export const currentYear = new Date().getUTCFullYear()

export const currentYearString = String(new Date().getUTCFullYear())
